import type { Extensions } from '@tiptap/core'
import type { MentionOptions } from '@tiptap/extension-mention'
import StarterKit from '@tiptap/starter-kit'
import { PostMention } from 'modules/community/components/editor/extensions/mention-extension'

export const createCommentExtensions = (
  mentionSuggestion?: MentionOptions['suggestion'],
): Extensions => [
  StarterKit.configure({
    heading: false,
    code: false,
    codeBlock: false,
    blockquote: false,
    horizontalRule: false,
    hardBreak: false,
    trailingNode: false,
    strike: false,
    bulletList: false,
    orderedList: false,
    listItem: false,
    listKeymap: false,
    link: {
      openOnClick: false,
      autolink: false,
      HTMLAttributes: { target: '_blank' },
    },
  }),
  PostMention.configure({
    HTMLAttributes: { class: 'mention' },
    suggestion: mentionSuggestion,
  }),
]
